/* Everything Bagel presentation. Shopify and the existing cart own purchasing. */
(() => {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-hbp-eb]').forEach(root => {
      if (root.dataset.hbpReady) return;
      root.dataset.hbpReady = 'true';
      const form = root.querySelector('form[action*="/cart/add"]');
      const quantity = form?.querySelector('[name="quantity"]');
      const image = root.querySelector('.hbp-eb__image');
      root.querySelectorAll('[data-hbp-photo]').forEach(button => {
        button.addEventListener('click', () => {
          if (!(image instanceof HTMLImageElement)) return;
          image.removeAttribute('srcset');
          image.src = button.dataset.image;
          image.alt = button.dataset.imageAlt;
          root.querySelectorAll('[data-hbp-photo]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
      root.querySelectorAll('[data-hbp-quantity-change]').forEach(button => {
        button.addEventListener('click', () => {
          if (!quantity) return;
          if (button.dataset.hbpQuantityChange === '1') quantity.stepUp(); else quantity.stepDown();
          quantity.dispatchEvent(new Event('change', {bubbles:true}));
        });
      });
      const variants = JSON.parse(root.querySelector('[data-hbp-variants]').textContent);
      let subscriptionConfig = null;
      function updateSubscriptionNote() {
        const variant = variants.find(item => String(item.id) === String(form?.elements.id?.value));
        const eligible = subscriptionConfig?.enabled === true && variant?.available && subscriptionConfig.plans?.some(plan => !plan.prepaid && plan.interval === 'MONTH' && plan.intervalCount === 1 && variant.planIds.some(id => String(id) === String(plan.sellingPlanId)));
        root.querySelector('[data-hbp-subscription]').hidden = !eligible;
      }
      root.querySelector('[data-hbp-variant]')?.addEventListener('change', event => {
        const variant = variants.find(item => String(item.id) === event.target.value);
        if (!variant) return;
        root.querySelector('[data-hbp-price]').textContent = variant.price;
        root.querySelector('[data-hbp-add]').disabled = !variant.available;
        root.querySelector('[data-hbp-add-label]').textContent = variant.available ? 'Add to cart' : 'Sold out';
        quantity.min = variant.min;
        quantity.step = variant.step;
        if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
        quantity.value = variant.min;
        updateSubscriptionNote();
      });
      if (variants.some(variant => variant.planIds.length)) {
        const base = (root.dataset.root || '/').replace(/\/?$/, '/');
        fetch(base + 'apps/manage-subscriptions?r=config', {credentials:'same-origin'})
          .then(response => response.ok ? response.json() : null)
          .then(config => {
            subscriptionConfig = config;
            updateSubscriptionNote();
          }).catch(() => {});
      }
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
